import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

/** Ce qui ouvre le brouillon : un R1 (bloc « Après le R1 ») ou une carte (« Préparer le devis »). */
export interface QuoteDraftTarget {
  r1Key?: string;
  actionId?: string;
}

/**
 * Lot AT : le grand volet du brouillon de devis, monté une fois dans la coquille et ouvert depuis le volet du R1 ou
 * une carte de « À faire ». `open` rend, à la fermeture, vrai si quelque chose a changé (l'écran recharge alors).
 */
export const useQuoteDraftStore = defineStore('quoteDraft', () => {
  const target = ref<QuoteDraftTarget | null>(null);
  const changed = ref(false);
  const isOpen = computed(() => target.value !== null);
  let settle: ((changed: boolean) => void) | null = null;

  function close(): void {
    const resolve = settle;
    const didChange = changed.value;
    settle = null;
    target.value = null;
    changed.value = false;
    resolve?.(didChange);
  }

  function open(next: QuoteDraftTarget): Promise<boolean> {
    if (settle) close();
    target.value = { ...next };
    changed.value = false;
    return new Promise((resolve) => {
      settle = resolve;
    });
  }

  function markChanged(): void {
    changed.value = true;
  }

  return { target, isOpen, open, close, markChanged };
});
